import { Component } from '../Component';

/**
 * CombatComponent - Combat state and attack parameters
 */
export class CombatComponent extends Component {
  public readonly type = 'combat';

  /** Whether entity is currently in combat */
  public inCombat: boolean;

  /** Current combat target entity ID */
  public targetEntityId: string | null;

  /** Attack speed in attacks per second */
  public attackSpeed: number;

  /** Attack range in world units */
  public attackRange: number;

  /** Base attack damage (can be overridden by BeastieComponent stats) */
  public baseDamage: number;

  /** Time of last attack (ms timestamp) */
  public lastAttackTime: number;

  /** Whether this entity can initiate combat */
  public canInitiateCombat: boolean;

  /** Whether this entity is hostile (will attack enemies on sight) */
  public isHostile: boolean;

  constructor(data?: Partial<CombatComponent>) {
    super();
    this.inCombat = data?.inCombat ?? false;
    this.targetEntityId = data?.targetEntityId ?? null;
    this.attackSpeed = data?.attackSpeed ?? 1; // 1 attack per second
    this.attackRange = data?.attackRange ?? 1.5; // 1.5 world units
    this.baseDamage = data?.baseDamage ?? 10;
    this.lastAttackTime = data?.lastAttackTime ?? 0;
    this.canInitiateCombat = data?.canInitiateCombat ?? true;
    this.isHostile = data?.isHostile ?? false;
  }

  /**
   * Get cooldown duration in milliseconds
   */
  public get attackCooldownMs(): number {
    return 1000 / this.attackSpeed;
  }

  /**
   * Check if attack is off cooldown
   */
  public canAttack(currentTime: number): boolean {
    return currentTime - this.lastAttackTime >= this.attackCooldownMs;
  }

  /**
   * Record an attack
   */
  public recordAttack(currentTime: number): void {
    this.lastAttackTime = currentTime;
  }

  /**
   * Enter combat with a target
   */
  public engageTarget(targetId: string): void {
    this.inCombat = true;
    this.targetEntityId = targetId;
  }

  /**
   * Exit combat
   */
  public disengage(): void {
    this.inCombat = false;
    this.targetEntityId = null;
  }
}
